import { request } from '../lib/http'

export function fetchClients () {
  return request({
    url: 'arena-clients',
    method: 'get'
  })
}

export function addRemoteID (data) {
  return request({
    method: 'post',
    url: 'add-remote-id',
    data
  })
}

export function fetchVehiclesByClient (data) {
  return request({
    method: 'get',
    url: 'vehicles-by-client',
    params: data
  })
}

export function fetchEvents (data) {
  return request({
    method: 'get',
    url: 'arenaevents',
    params: data
  })
}

export function fetchAllDataForm (data) {
  return request({
    method: 'get',
    url: 'arenaevents-all-data-form',
    params: data
  })
}

export function createArenaEvent (data) {
  return request({
    method: 'post',
    url: 'add-arena-event',
    data
  })
}

export function fetchEventById (id) {
  return request({
    method: 'get',
    url: `show-arena-event/${id}`,
  })
}

export function editArenaEvent (id, data) {
  return request({
    url: `edit-arena-event/${id}`,
    method: 'patch',
    data
  })
}

export function fetchEquipments (params) {
  return request({
    url: 'arena/equipments',
    method: 'get',
    params
  })
}

export function fetchEquipmentById (id) {
  return request({
    method: 'get',
    url: `arena/equipment/${id}`,
  })
}

export function createEquipment (data) {
  return request({
    method: 'post',
    url: 'arena/equipment',
    data
  })
}

export function editEquipment (id, data) {
  return request({
    url: `arena/equipment/${id}`,
    method: 'patch',
    data
  })
}

export function fetchArenaEquipmentVersions () {
  return request({
    url: 'arena/versions',
    method: 'get'
  })
}

export function fetchArenaEquipmentVersionById (id) {
  return request({
    method: 'get',
    url: `arena/version/${id}`,
  })
}

export function createEquipmentVersion (data) {
  return request({
    method: 'post',
    url: 'arena/version',
    data
  })
}

export function editEquipmentVersion (id, data) {
  return request({
    url: `arena/version/${id}`,
    method: 'patch',
    data
  })
}

export function fetchArenaVehicleTypes () {
  return request({
    url: 'arena/vehicletypes',
    method: 'get'
  })
}

export function fetchArenaVehicleTypeById (id) {
  return request({
    method: 'get',
    url: `arena/vehicletype/${id}`,
  })
}

export function createVehicleType (data) {
  return request({
    method: 'post',
    url: 'arena/vehicletype',
    data
  })
}

export function editVehicleType (id, data) {
  return request({
    url: `arena/vehicletype/${id}`,
    method: 'patch',
    data
  })
}

export function fetchArenaPointTypes () {
  return request({
    url: 'arena/pointtypes',
    method: 'get'
  })
}

export function fetchArenaPointTypeById (id) {
  return request({
    method: 'get',
    url: `arena/pointtype/${id}`,
  })
}

export function createPointType (data) {
  return request({
    method: 'post',
    url: 'arena/pointtype',
    data
  })
}

export function editPointType (id, data) {
  return request({
    url: `arena/pointtype/${id}`,
    method: 'patch',
    data
  })
}

export function fetchArenaUserTypes () {
  return request({
    url: 'arena/usertypes',
    method: 'get'
  })
}

export function fetchArenaUserTypeById (id) {
  return request({
    method: 'get',
    url: `arena/usertype/${id}`,
  })
}

export function createUserType (data) {
  return request({
    method: 'post',
    url: 'arena/usertype',
    data
  })
}

export function editUserType (id, data) {
  return request({
    url: `arena/usertype/${id}`,
    method: 'patch',
    data
  })
}

export function fetchArenaUsers (params) {
  return request({
    url: 'arena/users',
    method: 'get',
    params
  })
}

export function fetchArenaUsersByCompany (company) {
  return request({
    url: `arena/users-by-company/${company}`,
    method: 'get'
  })
}

export function fetchArenaUserById (id) {
  return request({
    method: 'get',
    url: `arena/user/${id}`,
  })
}

export function createUser (data) {
  return request({
    method: 'post',
    url: 'arena/user',
    data
  })
}

export function editUser (id, data) {
  return request({
    url: `arena/user/${id}`,
    method: 'patch',
    data
  })
}

export function fetchVehicles (data) {
  return request({
    url: 'arena/vehicles',
    method: 'get',
    params: data
  })
}

export function fetchVehiclesAndAreas (data) {
  return request({
    url: 'arena/vehicles-and-areas-generate-events',
    method: 'get',
    params: data
  })
}

export function fetchVehiclesAndAreasByClient (data) {
  return request({
    method: 'get',
    url: 'arena/vehicles-and-areas-by-client',
    params: data
  })
}

export function linkVehicleAndArea (data) {
  return request({
    method: 'post',
    url: 'arena/link-vehicle-and-area',
    data
  })
}

export function fetchAreas (data) {
  return request({
    url: 'arena/areas',
    method: 'get',
    params: data
  })
}

export function unlinkVehicleAndAreaGenerateEvents (data) {
  return request({
    method: 'post',
    url: 'arena/unlink-vehicle-and-area-generate-events',
    data
  })
}

export function fetchPositionsVWVData (data) {
  return request({
    url: 'arena/positions-vw-vdata',
    method: 'get',
    params: data
  })
}

export function removePositionDadoLido (data) {
  return request({
    method: 'post',
    url: 'arena/remove-position-dado-lido',
    data
  })
}

export function fetchTriggeredEvents (data) {
  return request({
    url: 'arena/vw-deactivated-events',
    method: 'get',
    params: data
  })
}

export function removeTriggeredEvent (data) {
  return request({
    method: 'post',
    url: 'arena/remove-triggered-event',
    data
  })
}

export function inactivateArenaEvent (id) {
  return request({
    url: `inactivate-arena-event/${id}`,
    method: 'patch'
  })
}
